export enum NoteType {
  UNIT_NOTE = 'unit_note',
  PROJECT_NOTE = 'project_note',
  CONTACT_NOTE = 'contact_note',
  MARKETING_TITLE = 'marketing_title',
  MARKETING_DESCRIPTION = 'marketing_description',
  WARNING_MESSAGE = 'warning_message'
}
